export const URLs = {
  fortumFi: { url: 'https://www.fortum.fi', name: 'fortum.fi' },
};
